import React, { useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';
import DefaultApi from '../../Api/DefaultApi';

const ImageUploadEditor = ({
  rowData,
  uploadImage,
}) => {
  const inputRef = useRef();
  const [image, setImage] = useState(
    rowData.ImageData
      ? `data:image/${
          rowData.ImagePath.split('.')[
            rowData.ImagePath.split('.').length - 1
          ]
        };base64,${rowData.ImageData}`
      : ''
  );

  const handleDrop = async ([file]) => {
    if (!file) {
      toast.warning('Please select PNG or JPEG file');
      return;
    }

    let company_id = rowData.id;
    await DefaultApi.uploadCompanyPhoto(company_id, file, (res) => {
      if (res.status === 200) {
        setImage('data:image/png;base64,' + res.data);
        uploadImage(res.data);
      } else toast.error(res.message);
    });
  };

  return (
    <Dropzone
      accept="image/jpeg, image/png"
      className="avatar"
      onDrop={handleDrop}
    >
      {({ getRootProps, getInputProps }) => (
        <section className="container">
          <div {...getRootProps({ className: 'avatar' })} ref={inputRef}>
            <input {...getInputProps()} />
            {image ? (
              <img
                alt="demo"
                src={image}
                style={{
                  width: 60,
                  height: 60,
                  objectFit: 'contain',
                }}
              />
            ) : (
              <p style={{ fontSize: 12, padding: 2 }}>
                Try dropping some files here, or click to select files to upload.
              </p>
            )}
          </div>
        </section>
      )}
    </Dropzone>
  );
};

export default ImageUploadEditor;
